module.exports = __webpack_public_path__ + "media/images/front/icons/book-2cde7de0a3b9e681dd6ac43bcf8939aa.png";